var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.0147L13.4979 17.856C14.2075 18.3042 15.0828 17.6381 14.8946 16.794L13.7006 11.4381L17.6753 7.83409C18.3017 7.26657 17.9667 6.18934 17.1412 6.11639L11.9093 5.65215L9.86264 0.597593C9.53949 -0.199198 8.46051 -0.199198 8.13736 0.597593L6.09074 5.65215L0.858783 6.11639C0.0332557 6.18934 -0.301662 7.26657 0.324725 7.83409L4.29938 11.4381L3.10545 16.794C2.91717 17.6381 3.79248 18.3042 4.50215 17.856L9 15.0147Z",
    fill: "#FAB73B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRating);
export default __webpack_public_path__ + "static/media/star_rating.c28dffc68e945685d74cbfc66a2d76b3.svg";
export { ForwardRef as ReactComponent };